import { graphql } from 'react-relay/hooks'
import { useMutation } from 'hooks'

const mutation = graphql`
  mutation useReportResolutionUpdateMutation(
    $input: UpdateReportResolutionInput!
    $resolutionSection: String
    $anomalies: [String]
  ) {
    updateReportResolution(input: $input) {
      reportResolution {
        id
        currentValue
        initialValue
        resolutionKind
        status
        updateStatus
        anomalyTypes
        report {
          reviewStatus
          resolutionProgress
          ...ReportResolution_report
          ...ReportResolutionTable_report
        }
      }
    }
  }
`

export default function useReportResolutionUpdate() {
  return useMutation(mutation, 'updateReportResolution')
}
